import React from 'react';
import { FieldInputProps } from 'react-final-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { EntityTypeId } from 'services/entityTypes/types';
import {
    SprayEventEndDate,
    SprayEventEntityId,
    SprayEventId,
    SprayEventStartDate
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import RenderSubmissionSprayEventsTable from '../RenderSubmissionSprayEventsTable';
import { SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME } from './constants';
import {
    makeSelectSelectedSprayEventIdsForSubmissionPaginated,
    selectSprayEventIdsForSubmissionLength
} from './selectors';

export interface OwnProps {
    input: FieldInputProps<any, HTMLElement>;
    startDate?: SprayEventStartDate;
    endDate?: SprayEventEndDate;
    entityId?: SprayEventEntityId;
    spraySchemaInnerEntityTypeId: EntityTypeId;
    spraySchemaEntityTypeId: EntityTypeId;
}

interface ConnectedProps {
    sprayEventIds: SprayEventId[];
    sprayEventIdsLength: number;
}

type Props = OwnProps & ConnectedProps;

export class SubmissionsSelectedSprayEventIdsFieldComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const {
            input,
            startDate,
            endDate,
            entityId,
            spraySchemaInnerEntityTypeId,
            spraySchemaEntityTypeId,
            sprayEventIds,
            sprayEventIdsLength
        } = this.props;

        return (
            <RenderSubmissionSprayEventsTable
                input={input}
                startDate={startDate}
                endDate={endDate}
                entityId={entityId}
                spraySchemaInnerEntityTypeId={spraySchemaInnerEntityTypeId}
                spraySchemaEntityTypeId={spraySchemaEntityTypeId}
                sprayEventIds={sprayEventIds}
                sprayEventIdsLength={sprayEventIdsLength}
                paginationName={SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    sprayEventIds: makeSelectSelectedSprayEventIdsForSubmissionPaginated(),
    sprayEventIdsLength: selectSprayEventIdsForSubmissionLength
});

export default connect(mapStateToProps)(
    SubmissionsSelectedSprayEventIdsFieldComponent
);
